<template>
    <p v-if="remainingSeconds > 0">
        <label>Nog {{ remainingPretty }} {{ message }}</label>
        <b-progress :value="remainingSeconds" :max="durationSeconds" striped animated></b-progress>
    </p>
    <p v-else-if="friendlyMode">
        <label>Ga verder naar het volgende bericht.</label>
    </p>
    <p v-else>
        <label>Te laat om nog te beslissen.</label>
    </p>
</template>

<script>
export default {
    data() {
        return {
            value: 50,
            max: 100
        }
    },
    props: {
        durationSeconds: {
            type: Number,
            required: true
        },
        remainingSeconds: {
            type: Number,
            required: true
        },
        message: {
            type: String,
            default: 'om te beslissen!'
        },
        friendlyMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        remainingPretty() {
            console.log(this.remainingSeconds, this.durationSeconds);
            return new Date(this.remainingSeconds * 1000).toISOString().substr(14, 5);
        }
    }
}
</script>
  
<style scoped>
p {
    margin-top: 2rem;
    margin-bottom: 2rem;
}
</style>
